module.exports = __webpack_public_path__ + "media/icons/thief-circle-24-4efdf7bc.png";